(function() {
  function updateAiodPrice(container) {
    if (!container) return;

    const price = parseFloat(container.dataset.price) || 0;
    const compare = parseFloat(container.dataset.compare) || 0;
    const currency = (Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';

    const originalEl = container.querySelector(".aiod-price-original");
    const discountedEl = container.querySelector(".aiod-price-discounted");
    const badgeEl = container.querySelector(".aiod-discount-badge");

    if (compare > price) {
      if (originalEl) {
        originalEl.textContent = compare.toLocaleString('nl-NL', { style: 'currency', currency: currency });
        originalEl.style.display = 'inline';
        originalEl.style.textDecoration = 'line-through';
        originalEl.style.color = '#888';
        originalEl.style.marginRight = '0.5rem';
      }
      if (discountedEl) {
        discountedEl.textContent = price.toLocaleString('nl-NL', { style: 'currency', currency: currency });
        discountedEl.style.display = 'inline';
        discountedEl.style.fontWeight = 'bold';
        discountedEl.style.color = '#d00';
      }
      if (badgeEl) {
        const percent = Math.round((compare - price) / compare * 100);
        badgeEl.textContent = `-${percent}%`;
        badgeEl.style.display = 'inline';
        badgeEl.style.backgroundColor = '#ffdede';
        badgeEl.style.borderRadius = '4px';
        badgeEl.style.padding = '0 4px';
        badgeEl.style.fontSize = '14px';
        badgeEl.style.marginLeft = '0.5rem';
      }
    } else {
      if (originalEl) originalEl.style.display = 'none';
      if (discountedEl) discountedEl.style.display = 'none';
      if (badgeEl) badgeEl.style.display = 'none';
    }

    container.classList.add("aiod-processed");
  }

  function initAiodPrices() {
    const containers = document.querySelectorAll(".aiod-price-crossout-container:not(.aiod-processed)");
    containers.forEach(updateAiodPrice);
  }

  // Detecteer dynamisch geladen producten (Broadcast AJAX)
  const observer = new MutationObserver(initAiodPrices);
  observer.observe(document.body, { childList: true, subtree: true });

  // Eerste run bij paginaload
  initAiodPrices();
})();


